export default {
  setGroupList (state: any, payload: any) {
    state.groupData = payload
  },
  setSearchText (state: any, payload: string) {
    state.searchText = payload
  },
  setSortName (state: any, name: string) {
    state.sortName = name
  },
  setSortAsc (state: any, sort: boolean) {
    state.sortAsc = sort
  }
}
